module.exports = __webpack_public_path__ + "static/img/college7.c345dc3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college7.jpeg
// module id = YVp+
// module chunks = 45